import Rails from '@rails/ujs';

export const debounce = (callback, time) => {
  let timeout;

  return function () {
    const context = this;
    const args = arguments;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(function () {
      timeout = null;
      callback.apply(context, args);
    }, time);
  }
};

export const loadAutocomplete = (input, results, urlFunction) => {
  const debounceMs = 150;
  const form = input.closest('#search');
  const freeSearch = form.querySelector('#search_free_search');
  const elementsToTriggerNewSearch = form.querySelectorAll('#search_query, #search_location_value, [type=submit]');

  form.addEventListener('ajax:before', (evt) => {
    // if it's a free search clear up any previously
    // selected category, tag or group
    if(freeSearch.value == 'true') {
      clearSearchParams();
    }

    // if the focused element that triggered the search is one from the
    // search bar we will consider this a new search and will clear any
    // selected filter
    if(Array.from(elementsToTriggerNewSearch).includes(document.activeElement)) {
      clearFilters(form)
    }
  });

  ['keypress', 'paste'].forEach((event) => {
    input.addEventListener(event, () => {
      // as soon as someone starts writing something
      // set the free search to true
      // also trigger on paste
      freeSearch.value = true;
    });
  });


  ['keyup', 'focus'].forEach(function (event) {
    // only clear results when making a new search
    results.innerHTML = "";
    results.scrollTop = 0;
    input.addEventListener(event, debounce((ev) => {
        if (input.value.length >= 2) {
          if(ev.keyCode == 40) {
            const firstRadio = results.querySelector('input[type=radio]');
            if(firstRadio) {
              firstRadio.checked = true;
              firstRadio.focus();
            }
            return
          }
          // don't even try to search suggestions if empty string is supplied
          // or if we pressed enter
          if((input.value.trim() == '') || (ev.keyCode == 13)) {
            return
          }
          Rails.ajax({
            type: "GET",
            url: urlFunction(input.value),
            success: function (response) {
              if (this.url == urlFunction(input.value)) {
                if (!response.body.innerHTML) {
                  results.classList.add('hide');
                  return
                }
                results.innerHTML = response.body.innerHTML;
                results.classList.remove('hide')
                const radioButtons = results.querySelectorAll('input[type=radio]');
                const suggestions = results.querySelectorAll('[data-linkable=false]');
                suggestions.forEach((suggestion) => {
                  const suggestionID = suggestion.getAttribute('data-id');
                  const suggestionName = suggestion.querySelector('.suggestion-name').textContent;
                  const suggestionTarget = suggestion.getAttribute('data-target');
                  suggestion.addEventListener('click', () => {
                    freeSearch.value = false;
                    updateFormID(form, suggestionTarget, suggestionID)
                    updateField(input, suggestionName)
                    results.classList.add('hide');
                  })
                })

                // since we are using radio buttons to be able
                // to navigate the list we need to listen to certain events
                // (example: enter key) and do stuff accordingly

                radioButtons.forEach((radio, i) => {
                  const suggestion = results.querySelector(`[data-id="${radio.value}"]`)
                  radio.addEventListener('focus', (evt) => {
                    if(radio == radioButtons[0] || radioButtons[radioButtons.length - 1] == radio) {
                      // if we are on the first or the last element we don't want to scroll
                      // this prevents some weird scroll issues on the body
                      return
                    }
                    suggestion.scrollIntoView({
                      behavior: 'auto',
                      block: 'center',
                      inline: 'nearest'
                    });
                  })
                  radio.addEventListener('keydown', (evt) => {
                    // only do stuff if enter key is pressed
                    if(evt.keyCode == 13) {
                      evt.preventDefault();
                      const suggestionID = suggestion.getAttribute('data-id');
                      const suggestionName = suggestion.querySelector('.suggestion-name').textContent;
                      const suggestionTarget = suggestion.getAttribute('data-target');

                      if(suggestion.getAttribute('data-linkable') == 'true') {
                        // if data-linkable is true (or not set for some reason)
                        // this means that it's actually a link
                        // so selecting this should be the same as clicking the link
                        // find the link and click then
                        suggestion.querySelector('a').click()
                      } else {
                        updateFormID(form, suggestionTarget, suggestionID)
                        updateField(input, suggestionName)
                      }
                      results.classList.add('hide')
                    }
                  })
                })
              };
            },
            error: function (response) { }
          });
        } else {
          results.classList.add('hide')
        };
      }, debounceMs)
    );
  });

  // Clicking anywhere outside of the results/suggestions box closes it
  document.addEventListener("click", function (event) {
    if (!event.target.closest("." + results.className) && event.target.id != input.id) {
      results.classList.add('hide')
    };
  });
}

// given a type and value update the
// supplied form values
const updateFormID = (form, type, value) => {
  if(type != 'location') {
    // reset values before updating field
    // only if the type isn't location
    // otherwise we are clearing stuff that we shouldn't clear
    clearSearchParams();
  }
  const formID = form.querySelector(`#search_${type}_id`);
  formID.value = value;
}

const clearSearchParams = () => {
  document.querySelectorAll("[data-search-parameter]").forEach((searchParameter) => {
    searchParameter.value = "";
  });
}

const clearFilters = (form) => {
  form.querySelectorAll('input[name^=search]:checked').forEach((filter) => {
    filter.checked = false
  })
}

const updateField = (field, value) => {
  const event = new Event('selected-suggestion')
  field.dispatchEvent(event)
  field.value = value;
}
